import React, { Component } from "react";
import Helmet from "react-helmet";

import "./NoMatch.css";

class NoMatch extends Component {
  render() {
    return (
      <div className="nomatch-wrapper">
        <Helmet>
          <title>Page Not Found (Error 404)</title>
        </Helmet>
        <div className="nomatch-content">
          <img
            width={100}
            alt="Icon of a document with an exclaimation point."
            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIzMnB4IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMycHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48dGl0bGUvPjxkZXNjLz48ZGVmcy8+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSI+PGcgZmlsbD0iIzkyOTI5MiIgaWQ9Imljb24tNzgtZG9jdW1lbnQtZXJyb3IiPjxwYXRoIGQ9Ik0xNC4wMDY5NDQ0LDI5IEw2Ljk5NzQyMTkxLDI5IEM1Ljg5MDkyNTM5LDI5IDUsMjguMTAxMjg3OCA1LDI2Ljk5MjY3MDEgTDUsNC4wMDczMjk5NCBDNSwyLjg5ODMzODMyIDUuODk5MjQ5NiwyIDcuMDA4NTMwMiwyIEwxNywyIEwxNyw4LjAwMTg5ODY1IEMxNyw5LjExMzI5MzY1IDE3Ljg5ODA4MDYsMTAgMTkuMDA1OTE5MSwxMCBMMjQsMTAgTDI0LDIzLjkyOTQxMTggTDIwLjUsMTggTDE0LjAwNjk0NDQsMjkgTDE0LjAwNjk0NDQsMjkgTDE0LjAwNjk0NDQsMjkgWiBNMTgsMiBMMTgsNy45OTcwNzA2NyBDMTgsOC41NTA5NzMyNCAxOC40NTA5NzUyLDkgMTguOTkwNzc4LDkgTDI0LDkgTDE4LDIgTDE4LDIgWiBNMjAuNSwyMCBMMjcsMzEgTDE0LDMxIEwyMC41LDIwIEwyMC41LDIwIFogTTIwLDI0IEwyMCwyNyBMMjEsMjcgTDIxLDI0IEwyMCwyNCBMMjAsMjQgWiBNMjAsMjggTDIwLDI5IEwyMSwyOSBMMjEsMjggTDIwLDI4IEwyMCwyOCBaIiBpZD0iZG9jdW1lbnQtZXJyb3IiLz48L2c+PC9nPjwvc3ZnPg=="
          />
          <h3>Error 404</h3>
          <h1>Page not found</h1>
          <p>The requested URL could not be found on this server.</p>
        </div>
      </div>
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/containers/NoMatch.js